module.exports = __webpack_public_path__ + "static/media/mahdi.c447f514.jpg";